module.exports = __webpack_public_path__ + "img/logo.b497c63a.png";